import { classNames } from '@dimjs/utils';
import { forwardRef, ReactNode } from 'react';
import { NativeProps } from '../utils/native-props';
import { px2rem } from '../utils/pxrem';
import './style.less';

export type NativeScrollType = 'x' | 'y' | 'xy' | 'hidden';

export type NativeScrollProps = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
> & {
  scroll?: NativeScrollType;
  // height中 number 值为视觉稿高度
  height?: string | number;
  children: ReactNode | ReactNode[];
} & NativeProps;

/**
 * Html原生滚动条
 * ```
 * 当父节点存在高度时，滚动条才会生效，滚动条事件才会生效
 * ```
 */
export const NativeScroll = forwardRef<HTMLDivElement, NativeScrollProps>((props, ref) => {
  const { height, scroll, children, className, style, ...otherProps } = props;
  const dpiHeight = typeof height === 'number' ? px2rem(height) : height;
  const newStyle = { height: dpiHeight || '100%', ...style };

  const clsName = classNames(
    'v-native-scroll',
    {
      'v-native-scroll-x': scroll === 'x',
      'v-native-scroll-y': scroll === 'y',
      'v-native-scroll-hidden': scroll === 'hidden',
    },
    className,
  );

  return (
    <div className={clsName} style={newStyle} ref={ref} {...otherProps}>
      {children}
    </div>
  );
});

NativeScroll.defaultProps = {
  scroll: 'y',
};
